import { Component, Injector, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { PonticSelectorService } from '@modules/tooth-editor/services/pontic-selector.service';
import { ControlValueAccessorDirective } from '@shared/base-classes/control-value-accessor.directive';
import { MapperPipe } from '@shared/pipes/mapper.pipe';
import { IdName } from '@shared/models/id-name';

@Component({
	selector: 'rx-pontic-selector',
	templateUrl: './pontic-selector.component.html',
	styleUrls: ['./pontic-selector.component.scss'],
	standalone: true,
	imports: [CommonModule, MatRadioModule, ReactiveFormsModule, MatTooltipModule, MatFormFieldModule, FlexLayoutModule, TranslateModule, MapperPipe],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: PonticSelectorComponent,
			multi: true
		}
	]
})
export class PonticSelectorComponent extends ControlValueAccessorDirective<IdName> {
	@Input()
	isReadonly = false;
	@Input()
	name = '';
	@Input()
	options: IdName[];
	@Input()
	showLabel = true;

	constructor(
		private ponticSelectorService: PonticSelectorService,
		injector: Injector
	) {
		super(injector);
	}

	getSrcForPonticDesignImage(ponticDesign: IdName): string {
		return this.ponticSelectorService.getSrcForPonticDesignImage(ponticDesign);
	}

	getSrcForRadioButtonImg(): string {
		return this.ponticSelectorService.getSrcForRadioButtonImg();
	}

	addDefaultOptionForPontics(options: IdName[]): [null, ...IdName[]] {
		return [null, ...(options ?? [])];
	}
}
